import { BarcodeReader } from "dynamsoft-javascript-barcode";

BarcodeReader.license = 'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAxNTAwNTQ0LVRYbFhaV0pRY205cVgyUmljZyIsIm9yZ2FuaXphdGlvbklEIjoiMTAxNTAwNTQ0IiwiY2hlY2tDb2RlIjoxNjExMjA3NDIxfQ==';

BarcodeReader.engineResourcePath = "https://cdn.jsdelivr.net/npm/dynamsoft-javascript-barcode@9.3.1/dist/";
